import { IconButton } from '@twistopayments/design-system/components/atoms/button'
import { Markdown } from '@twistopayments/design-system/components/atoms/markdown'
import {
  Modal,
  ModalCloser,
} from '@twistopayments/design-system/components/atoms/modal'
import { WarningOutlineIcon } from '@twistopayments/design-system/icons/inline'
import { useRouter } from 'next/router'
import { isNil } from 'ramda'

import { useGetFlowData } from '@twisto/flow-views'
import { useIsMobile, useOpen } from '@twisto/hooks'

import * as styles from './debug-info.styles'

export const DebugInfo = () => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string

  const { flow } = useGetFlowData(sessionId)
  const { isOpen, handleOpen, handleClose } = useOpen(false)

  const isMobile = useIsMobile()

  if (!isNil(flow?.debugInfo)) {
    return (
      <>
        <IconButton
          color="warning"
          css={styles.iconButton}
          icon={WarningOutlineIcon}
          onClick={handleOpen}
        />
        <Modal
          aria-label="Debug info"
          noPadding={isMobile}
          opened={isOpen}
          variant="wide"
          onClickOutside={handleClose}
        >
          <ModalCloser onClick={handleClose} />
          <section css={styles.container}>
            <Markdown input={flow.debugInfo} />
          </section>
        </Modal>
      </>
    )
  }

  return null
}
